import {inject, Injectable, Signal} from '@angular/core';

import {RequestTools} from '@selpia/shared/data-access';
import {Measure} from '@selpia/shared/models';

import {MeasureStore} from '../state/measures.store';

@Injectable({
  providedIn: 'root',
})
export class MeasuresFacade {
  readonly #store: MeasureStore = inject(MeasureStore);

  readonly isLoading: Signal<boolean> = RequestTools.isSignalPending(this.#store.loadingStatus);
  readonly measures: Signal<Measure[] | undefined> = this.#store.measures;

  load() {
    this.#store.load();
  }
}
